export default [{
        key: 'PermissionPopup',
        getComponent: function () { return import('./PermissionPopup'); },
        width: 400,
        title: i18n.get('权限设置'),
        timeout: 400,
    }
];
